import { useState, useEffect } from "react";

/**
 * Gets and returns the device type the of what the user is currently using
 */
const useDeviceTypeHandler = () => {
  const [deviceType, setDeviceType] = useState("");
  const getDeviceType = () => {
    if (/Android/i.test(navigator.userAgent)) {
      setDeviceType("android");
    } else if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) {
      setDeviceType("iphone");
    } else {
      setDeviceType("other");
    }
  };

  useEffect(() => {
    getDeviceType();
  }, []);

  return deviceType;
};

export default useDeviceTypeHandler;
